__turbopack_context__.v({
  "amountButton": "dINsuW_amountButton",
  "amountButtonSelected": "dINsuW_amountButtonSelected",
  "amounts": "dINsuW_amounts",
  "container": "dINsuW_container",
  "customInput": "dINsuW_customInput",
  "error": "dINsuW_error",
  "input": "dINsuW_input",
  "inputError": "dINsuW_inputError",
  "inputWrapper": "dINsuW_inputWrapper",
  "prefix": "dINsuW_prefix",
});
